/**
 * "Anterior · N de M · Próxima" das listagens paginadas de Sales. Quem chama
 * decide o alinhamento e se mostra (`totalPages > 1`) — a lista de vendas
 * divide a linha com o total, a aba da oferta não.
 */
export function TablePagination({
  page,
  totalPages,
  disabled,
  onPageChange,
}: {
  page: number;
  totalPages: number;
  disabled?: boolean;
  onPageChange: (page: number) => void;
}) {
  const buttonClass =
    'border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) rounded-lg border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40';

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1 || disabled}
        className={buttonClass}
      >
        Anterior
      </button>
      <span className="text-(--color-text-secondary) text-xs">
        {page} de {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages || disabled}
        className={buttonClass}
      >
        Próxima
      </button>
    </div>
  );
}
